// rentlord\rl_frontend\src\components\AddApartment.js
import React, { useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from "../Navbar";
import Footer from "../Footer";
import axios from 'axios';
import { Container, Grid2, Button, Typography, TextField, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Link } from 'react-router-dom';
import GooglePlace from '../google_api/GoogleLocation';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { BUILDING_TYPE_CHOICES } from '../../constants/buildingTypes';
import LanguageSwitcher from '../LanguageSwitcher';

const AddApartment= () => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();
  const [location, setLocation] = useState({
   place_id: '',
   place_description: '',
   address: '',
   latitude: '',
   longitude: '',
  });

  const [formData, setFormData] = useState({
    user: user.id,
    square_footage: '',
    floor: '',
    rooms: '',
    levels: '',
    bedrooms: '',
    bathrooms: '',
    construction_year: '',
    building_type: '',
    internet: false,
    elevator: false,
    security_camera: false,
  });
  const [uploaded_photos, setUploadedPhotos] = useState([]);
  const [token, setToken] = useState('');

  useEffect(() => {
    // Retrieve token from localStorage
    const userData = JSON.parse(localStorage.getItem('user'));
    const storedToken = userData?.token || '';
    setToken(storedToken);
    setFormData(prevState => ({ ...prevState, user: userData?.id || '' }));
  }, []);


  const handlePlaceSelected = (placeDetails) => {
    setLocation({
      place_id: placeDetails.place_id,
      place_description: placeDetails.place_description,
      address: placeDetails.address,
      latitude: placeDetails.latitude,
      longitude: placeDetails.longitude,
    });
  };
  
  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePhotosChange = (event) => {
    const files = event.target.files;
    setUploadedPhotos(prevPhotos => [...prevPhotos, ...files]);
  };

  const handleDeletePhoto = (index) => {
    setUploadedPhotos((prevPhotos) => prevPhotos.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    // Append location fields to formData
    formDataToSend.append('place_id', location.place_id);
    formDataToSend.append('place_description', location.place_description);
    formDataToSend.append('address', location.address);
    formDataToSend.append('latitude', location.latitude);
    formDataToSend.append('longitude', location.longitude);
    // Append other form data fields
    Object.keys(formData).forEach(key => {
      formDataToSend.append(key, formData[key]);
    });
    // Append photo files to formData
    Array.from(uploaded_photos).forEach((photoURL, index) => {
      formDataToSend.append(`uploaded_photos[${index}]`, photoURL);
    });

    //console.log('Submitting formDataToSend:', formDataToSend);

    axios.post(`${process.env.REACT_APP_API_URL}/api/create-apartment/`, formDataToSend, {
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'multipart/form-data',
      }
    }).then(response => {
      alert('The asset added successfully!');
      // Extract the ID of the newly created apartment from the response
      const apartmentId = response.data.id;
      // Navigate to the EditApartment page with the apartment ID
      navigate(`/edit-apartment/${apartmentId}`);
    }).catch(error => {
      console.error(error);
      alert('Failed to add the asset. Please try again.'); // Show error message if request fails
    });
  };

  if (!user) {
    return <div>No user data available.</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Container style={{ flex: '1 0 auto', marginTop: '2rem', marginBottom: '2rem', padding: '2rem' }}>
        <Typography variant="h6" gutterBottom>{t('addApartment.title')}</Typography>
        <form onSubmit={handleSubmit}>
          <GooglePlace onPlaceSelected={handlePlaceSelected} />
          <TextField
            id="square-footage-input"
            name="square_footage"
            label={t('addApartment.squareFootage')}
            type="number"
            value={formData.square_footage}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            id="floor input"
            name="floor"
            label={t('addApartment.floor')}
            type="number"
            value={formData.floor}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            id="rooms input"
            name="rooms"
            label={t('addApartment.rooms')}
            type="number"
            value={formData.rooms}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            id="balcony-input"
            name="balcony"
            label={t('addApartment.balcony')}
            type="number"
            value={formData.levels}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            id="bedrooms input"
            name="bedrooms"
            label={t('addApartment.bedrooms')}
            type="number"
            value={formData.bedrooms}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            id="bathrooms input"
            name="bathrooms"
            label={t('addApartment.bathrooms')}
            type="number"
            value={formData.bathrooms}
            onChange={onChange}
            fullWidth
            margin="normal"
          />
          <TextField
            id="construction year"
            name="construction_year"
            label={t('addApartment.constructionDate')}
            type="date"
            value={formData.construction_year}
            onChange={onChange}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            margin="normal"
          />
          <FormControl margin="normal" fullWidth>
            <InputLabel>{t('addApartment.buildingType')}</InputLabel>
              <Select
                value={formData.building_type || ''}
                onChange={onChange}
                label={t('addApartment.buildingType')}
                name="building_type"
              >
                {BUILDING_TYPE_CHOICES.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
          </FormControl>
          <FormControl margin="normal" fullWidth>
            <InputLabel>{t('addApartment.internet')}</InputLabel>
            <Select
              label={t('addApartment.internet')}
              name="internet"
              value={formData.internet ? t('addApartment.yes') : t('addApartment.no')}
              onChange={(e) =>
                onChange({
                  target: {
                    name: "internet",
                    value: e.target.value === t('addApartment.yes'),
                  },
                })
              }
            >
              <MenuItem value={t('addApartment.yes')}>{t('addApartment.yes')}</MenuItem>
              <MenuItem value={t('addApartment.no')}>{t('addApartment.no')}</MenuItem>
            </Select>
          </FormControl>
          <FormControl margin="normal" fullWidth>
            <InputLabel>{t('addApartment.elevator')}</InputLabel>
            <Select
              label={t('addApartment.elevator')}
              name="elevator"
              value={formData.elevator ? t('addApartment.yes') : t('addApartment.no')}
              onChange={(e) =>
                onChange({
                  target: {
                    name: "elevator",
                    value: e.target.value === t('addApartment.yes'),
                  },
                })
              }
            >
              <MenuItem value={t('addApartment.yes')}>{t('addApartment.yes')}</MenuItem>
              <MenuItem value={t('addApartment.no')}>{t('addApartment.no')}</MenuItem>
            </Select>
          </FormControl>
          <FormControl margin="normal" fullWidth>
            <InputLabel>{t('addApartment.securityCamera')}</InputLabel>
            <Select
              label={t('addApartment.securityCamera')}
              name="security_camera"
              value={formData.security_camera ? t('addApartment.yes') : t('addApartment.no')}
              onChange={(e) =>
                onChange({
                  target: {
                    name: "security_camera",
                    value: e.target.value === t('addApartment.yes'),
                  },
                })
              }
            >
              <MenuItem value={t('addApartment.yes')}>{t('addApartment.yes')}</MenuItem>
              <MenuItem value={t('addApartment.no')}>{t('addApartment.no')}</MenuItem>
            </Select>
          </FormControl>
          <div style={{ margin: '20px 0' }}>
            <label htmlFor="photo-upload" style={{ cursor: 'pointer' }}>
              <Button
                variant="contained"
                color="primary"
                component="span"
              >
                {t('addApartment.addPhotos')}
              </Button>
            </label>
            <input
              id="photo-upload"
              type="file"
              multiple
              onChange={handlePhotosChange}
              accept="image/*"
              style={{ display: 'none' }}
            />
          </div>
          <Grid2 container spacing={2}>
            <Grid2 item xs={12}>
            </Grid2>
            {uploaded_photos.map((photoURL, index) => (
              <Grid2 item key={index}>
                <img
                  src={photoURL instanceof File ? URL.createObjectURL(photoURL) : photoURL}
                  alt=""
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  onError={() => console.log('Error loading image:', photoURL)}
                />
                <IconButton
                  aria-label="delete"
                  color="primary"
                  onClick={() => handleDeletePhoto(index)}
                >
                <DeleteIcon />
                </IconButton>
              </Grid2>
            ))}
          </Grid2>
          <Grid2 container spacing={5}>
            <Grid2 item>
              <Button variant="outlined" color="primary" sx={{ mt: 2 }} component={Link} to="/dashboard">
                {t('addApartment.discard')}
              </Button>
            </Grid2>
            <Grid2 item>
            <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
              {t('addApartment.save')}
            </Button>
            </Grid2>
          </Grid2>
        </form>
      </Container>
      <Footer />
    </div>
    );
  };

export default AddApartment;
